import { Link } from 'react-router-dom';
import { CheckCircle2, Clock, Bell } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../../components/ui/card';
import { Alert, AlertDescription } from '../../components/ui/alert';

export function WaitlistVerified() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="mx-auto mb-4">
            <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center">
              <CheckCircle2 className="h-12 w-12 text-white" />
            </div>
          </div>

          <CardTitle className="text-2xl font-bold text-gray-900">
            Email Verified!
          </CardTitle>

          <CardDescription className="text-base">
            You're officially on the waitlist
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <Alert className="border-green-200 bg-green-50">
            <CheckCircle2 className="h-4 w-4 text-green-600" />
            <AlertDescription className="text-green-800">
              Your email has been successfully verified. You're all set!
            </AlertDescription>
          </Alert>

          <div className="bg-gray-50 rounded-xl p-6 text-center space-y-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
              <Bell className="h-8 w-8 text-blue-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                What happens next?
              </h3>
              <p className="text-sm text-gray-600">
                We're reviewing applications in the order they're received.
                We'll send you an email when your account is approved and ready to use.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span>Typical review time: 1-3 business days</span>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col space-y-3">
          <Button
            asChild
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
          >
            <Link to="/">
              Return to Homepage
            </Link>
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            Have questions?{' '}
            <Link to="/contact" className="text-primary hover:underline">
              Contact our team
            </Link>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}

export default WaitlistVerified;
